<template>
  <div class="loot__one">
    <div class="name">{{ activeItem.title }}</div>
    <div class="time">
      <span>{{ $t("loot.time") }}</span>
      <i v-if="isPermanent(activeItem.reward)" class="icon icon-forever"></i>
      {{ itemDuration(activeItem.reward).text }}
    </div>
    <div class="image_block"><img :src="getItemImage" :alt="activeItem.title" /></div>
  </div>
</template>
<script>
import ItemDurationMixin from "../../Common/ItemDurationMixin";

export default {
  name: "LootOne",
  mixins: [ItemDurationMixin],
  props: {
    activeItem: Object,
  },
  computed: {
    getItemImage() {
      try {
        return require(`@/assets/arsenal/images/${this.activeItem.reward.item.id}.png`);
      } catch {
        let image_id = this.activeItem.reward.item.achievement
          ? `achive_${this.activeItem.reward.item.id}`
          : this.activeItem.reward.item.id;
        return `https://wf.cdn.gmru.net/static/wf.mail.ru/img/main/items/${image_id}.png`;
      }
    },
  },
};
</script>
